import {
  ACTION_TYPE_LANG,
} from "../actions/index";
//
const initialState = {
  translation: {},
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPE_LANG:
      return {
        ...state,
        translation: action.payload,
      };
    default:
      return state;
  }
};

export default rootReducer;